// extracted by mini-css-extract-plugin
var _1 = "ApplicantCreditCheckVerdictModalFields-moduleApplicantCreditCheckVerdictModalFields__UjWfL";
var _2 = "ApplicantCreditCheckVerdictModalFields-moduledocument__RAZxz";
var _3 = "ApplicantCreditCheckVerdictModalFields-moduledocumentLabel__yNVsz";
var _4 = "ApplicantCreditCheckVerdictModalFields-moduleradio__N9XJH";
var _5 = "ApplicantCreditCheckVerdictModalFields-modulesuffix__VBAdz";
var _6 = "ApplicantCreditCheckVerdictModalFields-moduleverification__nt9pK";
export { _1 as "ApplicantCreditCheckVerdictModalFields", _2 as "document", _3 as "documentLabel", _4 as "radio", _5 as "suffix", _6 as "verification" }
